import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d81521f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setup-address" }
const _hoisted_2 = { class: "mb_20 text-rt btn-block" }
const _hoisted_3 = { style: {"margin-top":"50px"} }

import { ref, watch } from 'vue'
import TaxTable from '@/components/tax/TaxTable.vue'
import EditTaxAccount from '@/components/tax/EditTaxAccount.vue'
import { t } from '@/plugins/i18n'

// const editTaxAccount = ref()

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const visible = ref(false)
const editData = ref({})
const add = () => {
  visible.value = true
  //   console.log(editTaxAccount)
  editData.value = {}
  // editTaxAccount.value.open()
}
const setupTax = ref()
const refresh = () => {
  setupTax.value.refresh()
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: add
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('添加新账号')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createBlock(_Suspense, null, {
        default: _withCtx(() => [
          _createVNode(TaxTable, {
            source: "setupTax",
            ref: (_value, _refs) => {
              _refs['setupTax'] = _value
              setupTax.value = _value
            }
          }, null, 512)
        ]),
        _: 1
      }))
    ]),
    _createVNode(EditTaxAccount, {
      ref: (_value, _refs) => {
        _refs['editTaxAccount'] = _value
      },
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      data: editData.value,
      onRefresh: refresh
    }, null, 8, ["visible", "data"])
  ]))
}
}

})